// ... existing code ...
import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import about from "@/views/about.vue";
import news from "@/views/news.vue";
import contact from "@/views/contact/index.vue";
import newsDetail from "@/views/newsDetail.vue";
import Activepi from "@/views/products/activepi.vue";
import products from "@/views/products/index.vue";
import cmo from "@/views/products/cmo.vue";
import activeDetail from "@/views/products/activeDetail.vue";
const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/home",
			redirect: "/",
		},
		{
			path: "/zh-cn",
			redirect: "/",
		},
		{
			path: "/",
			name: "home",
			component: HomeView,
			meta: { title: '首页' }
		},
		{
			path: "/products",
			name: "products",
			redirect: "/products/active",
			meta: { title: '产品服务' },
			children: [
				{
					path: "active",
					name: "active",
					component: products,
					meta: { title: '化学原料药' }
				},
				{
					path: "activeDetail",
					name: "activeDetail",
					component: products,
					meta: { title: '原料药详情' }
				},
				{
					path: "inter",
					name: "inter",
					component: products,
					meta: { title: '化药中间体' }
				},
				{
					path: "bioDrug",
					name: "bioDrug",
					component: products,
					meta: { title: '生物药' }
				},
				{
					path: "bioDrugIntermediate",
					name: "bioDrugIntermediate",
					component: products,
					meta: { title: '生物药中间体' }
				},
				{
					path: "bioEnzyme",
					name: "bioEnzyme",
					component: products,
					meta: { title: '生物催化酶' }
				},
				{
					path: "ref",
					name: "ref",
					component: products,
					meta: { title: '对照品' }
				},
				{
					path: "cmo",
					name: "cmo",
					component: products,
					meta: { title: 'CMO/CDMO业务' }
				},
			]
		},
		{
			path: "/about",
			redirect: "/about/company",
			meta: { title: '关于润众制药' },
			children: [
				{
					path: "company",
					name: "company",
					component: about,
					meta: { title: '企业概况' }
				},
				{
					path: "history",
					name: "history",
					component: about,
					meta: { title: '发展历程' }
				},
			]
		},
		{
			path: "/news",
			name: "news",
			component: news,
			meta: { title: '新闻与媒体' }
		},
		{
			path: "/newsDetail",
			name: "newsDetail",
			component: newsDetail,
			meta: { title: '新闻详情' }
		},
		{
			path: "/contact",
			name: "contact",
			component: contact,
			meta: { title: '联系我们' }
		},
	],
	scrollBehavior(to, from, savedPosition) {
		// 如果有保存的位置（如浏览器前进后退），则恢复到保存的位置
		if (savedPosition) {
			return savedPosition;
		}
		// 否则滚动到页面顶部
		return { top: 0 };
	}
})

// 全局路由守卫：动态设置页面标题
router.beforeEach((to, from, next) => {
  const companyName = '连云港润众制药有限公司';
  const routeTitle = to.meta.title || '';
  document.title = routeTitle ? `${routeTitle}-${companyName}` : companyName;
  next();
});

export default router